import React from 'react';
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Breadcrumb } from 'antd';

import { useOrganizationList } from 'modules/serviceRegister/hooks';

import * as Grid from "components/Grid";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import Card from 'components/Card';
import { LoadingOutlined } from '@ant-design/icons';

import cls from "./ServiceOrganizations.module.scss";

const OrganizationStats = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { items, isFetched } = useOrganizationList({
    enabled: true,
    params: {
      perPage: 1_000_000,
    }
  });
  
  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item> */}
        <Breadcrumb.Item href='/service-register'>{t('service-registers')}</Breadcrumb.Item>
        <Breadcrumb.Item>{t('organization_stats')}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <Title align='left' text={t('organization_stats')} />

      <Spacer size={40} />

      <Spacer size={40} />

      {items.length > 0 && (
        <Grid.Row gutter={[24, 24]}>
          {items
            .map(item => (
              <Grid.Col span={6} key={item.id}>
                <Card
                  id={item.id}
                  uuid={item.file_response.uuid}
                  name={item.name[i18n.language]}
                  count={item.count}
                  onClick={() => navigate(`/service-register/list?organization_id=${item.id}`)}
                />
              </Grid.Col>
            ))}
        </Grid.Row>
      )}

      {
        items.length === 0 && isFetched && (<div className={cls.noData}>{t('no_data')}</div>)
      }

      {
        !isFetched && (<div className={cls.loading}><LoadingOutlined /></div>)
      }

      <Spacer size={140} />
    </Container>
  )
}

export default OrganizationStats;